module.exports = __webpack_public_path__ + "public/img/15.281b217d.png";